import { ErrorCode, GenericResponseSecurityMultiResolutionResult, GenericResponseSecurityResolutionResult, SecurityMultiResolutionResult, SecurityResolutionResult } from '@blk/wealth-web-endpoint';
import * as toPairsIn from 'lodash/toPairsIn';

import { MultiResolveSecurityDetailsResponse } from './multi-resolve-security-details-response.model';
import { SecurityDetailsResponse } from './security-details-response.model';
import { mapErrorCodeToWweErrorCode, mapSecurityToWweSecurity } from './security-response-mappings';

export const mapSecurityDetailsResponseBodyToSecurityDetailsResponse = (response: GenericResponseSecurityResolutionResult): SecurityDetailsResponse => {
	const securityDetailsResponse: SecurityDetailsResponse = { securities: new Map() };
	(response?.resultList ?? []).forEach((securityResponseResult: SecurityResolutionResult) => {
		if (securityResponseResult.security) {
			securityDetailsResponse.securities.set(securityResponseResult.id, mapSecurityToWweSecurity(securityResponseResult.security));
		}
	});
	if (response.errorCodes) {
		const errorMap = new Map();
		toPairsIn(response.errorCodes).forEach((errorCode: [string, ErrorCode]) => errorMap.set(errorCode[0], mapErrorCodeToWweErrorCode(errorCode[1])));
		securityDetailsResponse.errorCodes = errorMap.size ? errorMap : null;
	}
	return securityDetailsResponse;
};

export const mapMultiResolveSecurityDetailsResponseBodyToMultiResolveSecurityDetailsResponse = (response: GenericResponseSecurityMultiResolutionResult): MultiResolveSecurityDetailsResponse => {
	const securityDetailsResponse: MultiResolveSecurityDetailsResponse = { securities: new Map() };
	(response?.resultList ?? []).forEach((securityResponseResult: SecurityMultiResolutionResult) => {
		if (securityResponseResult.securities) {
			securityDetailsResponse.securities.set(securityResponseResult.id, securityResponseResult.securities.map(security => mapSecurityToWweSecurity(security)));
		}
	});
	if (response.errorCodes) {
		const errorMap = new Map();
		toPairsIn(response.errorCodes).forEach((errorCode: [string, ErrorCode]) => errorMap.set(errorCode[0], mapErrorCodeToWweErrorCode(errorCode[1])));
		securityDetailsResponse.errorCodes = errorMap.size ? errorMap : null;
	}
	return securityDetailsResponse;
};
